export default __webpack_public_path__ + "static/media/CV.b25fa9ad.pdf";